'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var _regeneratorRuntime = _interopDefault(require('babel-runtime/regenerator'));
var _Promise = _interopDefault(require('babel-runtime/core-js/promise'));
var _asyncToGenerator = _interopDefault(require('babel-runtime/helpers/asyncToGenerator'));
require('isomorphic-fetch');
var R = _interopDefault(require('ramda'));

var _this = undefined;

/* global fetch */
var firstOrNull = R.compose(R.defaultTo(null), R.head);

var getCookie = R.compose(firstOrNull, function (name) {
  return (document.cookie || '').split(';').map(function (cookie) {
    return cookie.trim();
  }).filter(function (cookie) {
    return cookie.substring(0, name.length + 1) === name + '=';
  }).map(function (cookie) {
    return decodeURIComponent(cookie.substring(name.length + 1));
  });
});

// returns true for HTTP methods that do not require CSRF protection
var csrfSafeMethod = function csrfSafeMethod(method) {
  return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
  );
};

var headers = R.merge({ headers: {} });

var method = R.merge({ method: 'GET' });

var credentials = R.merge({ credentials: 'same-origin' });

var setWith = R.curry(function (path, valFunc, obj) {
  return R.set(path, valFunc(), obj);
});

var csrfToken = R.unless(R.compose(csrfSafeMethod, R.prop('method')), setWith(R.lensPath(['headers', 'X-CSRFToken']), function () {
  return getCookie('csrftoken');
}));

var jsonHeaders = R.merge({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

var formatRequest = R.compose(csrfToken, credentials, method, headers);

var formatJSONRequest = R.compose(formatRequest, jsonHeaders);

var fetchWithCSRF = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var response, text;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(path, formatRequest(init));

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.text();

          case 5:
            text = _context.sent;

            if (response.ok) {
              _context.next = 8;
              break;
            }

            return _context.abrupt('return', _Promise.reject([text, response.status]));

          case 8:
            return _context.abrupt('return', text);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchWithCSRF(_x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Calls to fetch but does a few other things:
 *  - turn cookies on for this domain
 *  - set headers to handle JSON properly
 *  - handle CSRF
 *  - non 2xx status codes will reject the promise returned
 *  - response JSON is returned in place of response
 */
var fetchJSONWithCSRF = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
    var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var response, statusCode, json;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(input, formatJSONRequest(init));

          case 2:
            response = _context2.sent;
            statusCode = response.status;
            _context2.prev = 4;
            _context2.next = 7;
            return response.json();

          case 7:
            json = _context2.sent;

            if (response.ok) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt('return', _Promise.reject(_extends({}, json, {
              errorStatusCode: statusCode
            })));

          case 10:
            return _context2.abrupt('return', json);

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2['catch'](4);
            return _context2.abrupt('return', _Promise.reject({ // eslint-disable-line
              error: _context2.t0,
              errorStatusCode: statusCode
            }));

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[4, 13]]);
  }));

  return function fetchJSONWithCSRF(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getCookie = getCookie;
exports.csrfSafeMethod = csrfSafeMethod;
exports.fetchWithCSRF = fetchWithCSRF;
exports.fetchJSONWithCSRF = fetchJSONWithCSRF;
